import Vue from "vue";
import Vuex, { ActionTree, StoreOptions } from "vuex";
import { leaderboard } from "./leaderboard";

Vue.use(Vuex);

export interface RootState {
  version: string;
}

const store: StoreOptions<RootState> = {
  state: {
    version: "1.0"
  },
  modules: {
    leaderboard
  }
};

export default new Vuex.Store<RootState>(store);
